<template>
  <div>
    <div class="container mt-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4>Reporte de Citas por Fecha</h4>
        <div v-if="citas.length > 0">
          <button @click="exportToCSV" class="btn btn-success">Exportar a CSV</button>
        </div>
      </div>
      <hr />
      <!-- Tabla de citas -->
      <div v-if="citas.length > 0" class="table-responsive mt-4">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>Fecha</th>
              <th>Hora</th>
              <th>Paciente</th>
              <th>Documento</th>
              <th>Médico</th>
              <th>Especialidad</th>
              <th>Motivo</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(cita, index) in citas" :key="index">
              <td>{{ cita.fechaCita }}</td>
              <td>{{ cita.horaDesde }} - {{ cita.horaHasta }}</td>
              <td>{{ cita.nombrePaciente }}</td>
              <td>{{ cita.documentoPaciente }}</td>
              <td>{{ cita.nombreMedico }}</td>
              <td>{{ cita.nombreEspecialidad }}</td>
              <td>{{ cita.nombreMotivoCita }}</td>
              <td>{{ cita.estadoCita }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mensaje si no hay citas -->
      <div v-else class="alert alert-warning mt-4" role="alert">
        No se encontraron citas para el rango de fechas seleccionado.
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true,
    },
    p_estado: {
      type: String,
      default: 'EN PROCESO',
    },
    p_fechaDesde: {
      type: String,
      required: true,
    },
    p_fechaHasta: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      citas: [],
    };
  },
  mounted() {
    this.fetchCitas();
  },
  watch: {
    p_fechaDesde: 'fetchCitas',
    p_fechaHasta: 'fetchCitas',
  },
  methods: {
    async fetchCitas() {
      if (!this.p_fechaDesde || !this.p_fechaHasta) return;
      try {
        const response = await api.get('/vwcitas/por-fecha-estado', {
          params: {
            idEmpresa: this.p_idEmpresa,
            estadoCita: this.p_estado,
            fechaDesde: this.p_fechaDesde,
            fechaHasta: this.p_fechaHasta,
          },
        });
        this.citas = response.data;
      } catch (error) {
        console.error('Error al obtener los datos:', error);
        this.citas = [];
      }
    },
    exportToCSV() {
      const headers = ['Fecha', 'Hora', 'Paciente', 'Documento', 'Médico', 'Especialidad', 'Motivo', 'Estado'];
      const csvRows = [
        headers.join(','), // Add headers
        ...this.citas.map(cita => [
          cita.fechaCita,
          `${cita.horaDesde} - ${cita.horaHasta}`,
          cita.nombrePaciente,
          cita.documentoPaciente,
          cita.nombreMedico,
          cita.nombreEspecialidad,
          cita.nombreMotivoCita,
          cita.estadoCita,
        ].join(',')), // Add data rows
      ].join('\n');

      const blob = new Blob([csvRows], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('hidden', '');
      a.setAttribute('href', url);
      a.setAttribute('download', 'Reporte_Citas_Por_Fecha.csv');
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
  },
};
</script>

<style scoped>
.table-responsive {
  max-height: 400px;
  overflow-y: auto;
}
</style>